var map = {
	"./PCM_Booth_Diamond_people_version_A1_4x3.png": "de03",
	"./PCM_Booth_Diamond_people_version_A2_4x3.png": "8344",
	"./PCM_Booth_Diamond_people_version_A3_4x3.png": "8a0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84d9";